import React from 'react';
import { isIOS } from 'react-device-detect';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import BaseInput from '../@common/BaseInput';
import { WorksheetBaseProps } from '../@types';
import NameAndDateLines from '../@common/NameAndDateLines';
import GroupedPageLines from '../@common/GroupedPageLines';
import { translate } from '../../translations/translator';
// Print styles are now handled globally in _print.scss
const t = key => translate('worksheet', key);
type WordsAndSpellingProps = WorksheetBaseProps & {
  value: string;
};

const SentencePrekto1 = ({ onChange, valueMap, printRef }: WordsAndSpellingProps) => {
  const bookFont = 'Print-Wide-Book';

  const classes = useStyles({});
  // Print styles are now handled globally in _print.scss
  const handleChange = ({ target }) => {
    const singleInputKey = 1;
    onChange({
      [singleInputKey]: target.value
    });
  };

  const baseInputStyles: any = {
    fontFamily: bookFont,
    color: '#000',
    style: {
      fontSize: 60,
      width: 1000,
      marginLeft: 26,
      marginTop: isIOS ? '29px' : '28px',
      color: '#000',
      position: 'relative !important'
    }
  };

  return (
    <LandscapePaperLayout isWide printRef={printRef}>
      <NameAndDateLines fontFamily={bookFont} isWide width={1000} top={-60} />
      <Box style={{ marginTop: '-10px' }}>
        <Box style={{ display: 'flex', justifyContent: 'center' }}>
          <Box className={classes.box} />
        </Box>
        <BaseInput
          onChange={handleChange}
          showBackground={true}
          {...baseInputStyles}
          placeholder={t('sentence')}
          value={valueMap[1]}
        />
        <GroupedPageLines top={60} width={1000} isWide paddingTop={30} />
        <GroupedPageLines top={98} width={1000} isWide paddingTop={30} />
      </Box>
    </LandscapePaperLayout>
  );
};

export default SentencePrekto1;

const useStyles = makeStyles(theme => ({
  box: {
    border: '2px solid black',
    height: '350px',
    width: '700px'
  }
}));
